import Model from "./abstract/Model";

export default class Attachment extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }

  // get url() {
  //   return config.app.api_url + '/attachments/' + this.id;
  // }

  get url_private() {
    return config.app.api_url + '/attachments/' + this.id;
  }
}
